export default __webpack_public_path__ + "static/media/kitchen-pack-16.31658493.png";